import { cardFactory } from '@liveauctioneers/hammer-ui-core/card/factory';
import { DateAndHouseComponent } from './components/DateAndHouseComponent';
import { EstimateComponent } from './components/EstimateComponent';
import { ImageComponent } from './components/ImageComponent';
import { ItemSummary } from '@/types/item/ItemSummary';
import { PriceAndMenuComponent } from './components/PriceAndMenuComponent';
import { PriceComponentExperiment } from './components/PriceComponentExperiment';
import { SellerNameComponentExperiment } from './components/SellerNameComponentExperiment';
import { StarRatingComponent } from './components/StarRatingComponent';
import { TitleComponent } from './components/TitleComponent';

export const SearchPageItemCard = cardFactory<ItemSummary & { position: number }>({
    components: [
        ImageComponent,
        DateAndHouseComponent,
        { spacerPx: 2 },
        TitleComponent,
        StarRatingComponent,
        EstimateComponent,
        PriceAndMenuComponent,
    ],
    name: 'SearchPageItemCard',
});

//Experiment SEAR-769: New similar items CTA experiment
export type SearchPageItemCardExperimentProps = ItemSummary & { position: number };

export const SearchPageItemCardExperiment = cardFactory<SearchPageItemCardExperimentProps>({
    components: [
        ImageComponent,
        DateAndHouseComponent,
        { spacerPx: 2 },
        TitleComponent,
        SellerNameComponentExperiment,
        EstimateComponent,
        PriceComponentExperiment,
    ],
    name: 'SearchPageItemCardExperiment',
});
